<!-- 优惠券管理 -->
<style scoped>
.img {
  height: 30px;
}
.ellipsis-1 {
  max-width: 180px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-wrap: break-word;
  word-break: break-all;
}
.w150 {
  width: 150px;
}
</style>
<template>
  <div class="pageCentent">
    <div style="background-color: #fff; padding: 16px; margin-bottom: 20px">
      <!-- 表格 -->
      <MyTable
        :isSelection="false"
        class="mt10"
        :apiUrl="apiUrl"
        :params="ajaxparams"
        ref="myTable"
        :columns="columns"
      >
        <a-space slot="button" slot-scope="item, row">
          <a-popconfirm
            title="确定删除?"
            ok-text="确定"
            cancel-text="取消"
            @confirm="delConfirm(row)"
          >
            <a-button size="small" type="danger">删除</a-button>
          </a-popconfirm>
        </a-space>

        <a-space slot="cover_img" slot-scope="item, row">
          <img
            v-if="(row.goods && row.goods.cover_img) || row.cover_img"
            style="width: 30px; height: 30px"
            :src="
              IMGHOST + '/' + (row.goods ? row.goods.cover_img : row.cover_img)
            "
          />
          <span v-else>-</span>
        </a-space>

        <a-space slot="goods_name" slot-scope="item, row">
          <span v-if="row.goods && row.goods.goods_name">{{
            row.goods.goods_name
          }}</span>
          <span v-else-if="row.goods_name">{{ row.goods_name }}</span>
          <span v-else>-</span>
        </a-space>

        <a-space slot="type" slot-scope="item, row">
          <span>{{ getTypeName(row.type) }}</span>
        </a-space>

        <a-space slot="amount" slot-scope="item, row">
          <span v-if="row.type === 1"
            >¥{{ (row.amount / 100).toFixed(2) }}</span
          >
          <span v-else>{{ row.amount / 10 }}折</span>
        </a-space>

        <a-space slot="condition" slot-scope="item, row">
          <span v-if="row.condition === 0">无门槛</span>
          <span v-else>满¥{{ (row.condition / 100).toFixed(2) }}</span>
        </a-space>

        <a-space slot="date_range" slot-scope="item, row">
          <span>{{ row.start_date }} 至 {{ row.end_date }}</span>
        </a-space>

        <a-space slot="target_id" slot-scope="item, row">
          <span>{{ row.target_id }}</span>
        </a-space>
      </MyTable>
    </div>
  </div>
</template>

<script>
import MyTable from "@/components/myTable.vue";
import { Coupon_index, Coupon_del } from "@/api/goods";

export default {
  components: { MyTable },
  data() {
    return {
      IMGHOST: window.IMGHOST,
      apiUrl: Coupon_index,
      ajaxparams: {
        page: 1,
        limit: 10,
      },
      columns: [
        {
          title: "商品图片",
          ellipsis: true,
          dataIndex: "cover_img",
          key: "cover_img",
          width: 80,
          scopedSlots: { customRender: "cover_img" },
        },
        {
          title: "商品名称",
          ellipsis: true,
          dataIndex: "goods_name",
          key: "goods_name",
          width: 150,
          scopedSlots: { customRender: "goods_name" },
        },
        {
          title: "优惠券名称",
          ellipsis: true,
          dataIndex: "coupon_name",
          key: "coupon_name",
          width: 180,
        },
        {
          title: "优惠类型",
          ellipsis: true,
          dataIndex: "type",
          key: "type",
          width: 80,
          scopedSlots: { customRender: "type" },
        },
        {
          title: "优惠金额/折扣",
          ellipsis: true,
          dataIndex: "amount",
          key: "amount",
          width: 100,
          scopedSlots: { customRender: "amount" },
        },
        {
          title: "使用条件",
          ellipsis: true,
          dataIndex: "condition",
          key: "condition",
          width: 100,
          scopedSlots: { customRender: "condition" },
        },

        {
          title: "有效期",
          ellipsis: true,
          dataIndex: "date_range",
          key: "date_range",
          width: 180,
          scopedSlots: { customRender: "date_range" },
        },
        {
          title: "操作",
          key: "operation",
          fixed: "right",
          width: 100,
          scopedSlots: { customRender: "button" },
        },
      ],
    };
  },
  created() {},
  mounted() {},
  destroyed() {},
  methods: {
    // 删除确认
    async delConfirm(val) {
      try {
        await Coupon_del({ id: val.id });
        this.$message.success("操作成功");
        setTimeout(() => {
          this.$refs.myTable.getList();
        }, 1500);
      } catch (error) {
        console.error("删除失败:", error);
      }
    },

    getTypeName(type) {
      const typeName = {
        1: "满减",
        3: "折扣",
      };
      return typeName[type] || "-";
    },
  },
};
</script>
